import { StatusPageEmbed } from "@/components/StatusPageEmbed";

// Iter 110ag → Iter 120 — Full-page Status Page app. It now renders the
// **public incident.io status page only** (fetched through our Widget API
// proxy and painted first-party, because incident.io blocks iframes).
// The old "native" panel (Pingdom uptime banners, manual Current Status card,
// maintenance callout) and the super-admin view toggle were removed on
// request — one source of truth for platform status.
export function StatusPagePanel({ appUrl }) {
  return (
    <div data-testid="status-page-app-incidentio">
      <StatusPageEmbed appUrl={appUrl} />
    </div>
  );
}
